export default __webpack_public_path__ + "a88d3327e8a861a509f946ea62b74fc6.jpg";